import type { CSSProperties } from 'react';
import { themeTableColumns } from './themeTableColumns';

type LayoutColumn = {
  width?: number | string;
  ellipsis?: unknown;
  hideInTable?: boolean;
  children?: object[];
  onCell?: (...args: never[]) => { style?: CSSProperties };
  onHeaderCell?: (...args: never[]) => { style?: CSSProperties };
};

// 仅用于招商、合同表格。明确宽度的短字段和省略列保持单行，说明列仍可自然换行。
// 列级样式避免平台的 overflow-wrap:anywhere 覆盖 Ant Table 的省略规则。
export function businessTableColumns<T extends object>(columns: T[]): T[] {
  return themeTableColumns(
    columns.map((column) => {
      const item = column as LayoutColumn;
      const result = { ...column } as T & LayoutColumn;
      if (item.children) result.children = businessTableColumns(item.children);
      result.onHeaderCell = (...args) => {
        const props = item.onHeaderCell?.(...args) || {};
        return {
          ...props,
          style: {
            ...props.style,
            whiteSpace: 'nowrap',
            overflowWrap: 'normal',
          },
        };
      };
      if (item.width || item.ellipsis) {
        result.onCell = (...args) => {
          const props = item.onCell?.(...args) || {};
          return {
            ...props,
            style: {
              ...props.style,
              whiteSpace: 'nowrap',
              overflowWrap: 'normal',
            },
          };
        };
      }
      return result;
    }),
  );
}

// 与列定义共用宽度预算，避免 scroll.x 小于列宽之和挤压字段。
// 未指定宽度的主内容列保留弹性；200 是其窄屏最小阅读宽度。
export function businessTableScroll(columns: readonly object[]): number {
  return columns.reduce((total, column) => {
    const item = column as LayoutColumn;
    if (item.hideInTable) return total;
    if (item.children) return total + businessTableScroll(item.children);
    return total + (typeof item.width === 'number' ? item.width : 200);
  }, 0);
}
